export default "__VITE_PUBLIC_ASSET__e0f02232__"